export default () => ({
    type: "CLEAR_VESSEL_IMAGES"
});